import React from "react";
import { CheckboxAntd } from "./styles";

export default function AntdCheckbox({ ...props }) {
	return <CheckboxAntd {...props} />;
}
